<template>
    <div class="invoice-container">

                <div class="row d-flex mb-3">
                    <div class="col-md col-12 mb-3 px-2">
                        <primary-select
                                v-model="company_uuid"
                                type="text"
                                name="Company"
                                :options="companies"
                        />

                           </div>
                    <div class="col-md col-12 mb-3 px-2">
                            <date-time-picker
                                    class="date-time"
                                    header="FROM"
                                    @getTime="getStartTime"
                                    header_font_size="12"
                                    header_font_weight="900"
                                    header_font_color="#000"
                            ></date-time-picker>
                                </div>
                    <div class="col-md col-12 mb-3 px-2">
                            <date-time-picker
                                    class="date-time"
                                    header="TO"
                                    @getTime="getEndTime"
                                    header_font_size="12"
                                    header_font_weight="900"
                                    header_font_color="#000"
                            ></date-time-picker>


                    </div>
                    <div class="col-md col-12 px-2 d-flex align-items-center">
                        <div class="primary-button ml-0 ml-md-auto mr-0">
                            <primary-button
                                    @click.native="$router.push({ name: 'system-admin-invoice-add' })"
                            >Add Invoice
                            </primary-button
                            >
                        </div>
                    </div>
                </div>

        <loader :loading="loading" v-if="loading"/>
        <template v-if="!loading">
            <not-found v-if="isFound"/>
            <div v-else class="table_div" style="width: 100%; overflow-x: auto">
                <table class="Invoice_table">
                    <thead>
                    <tr class="Invoice_table_header">
                        <th>Invoice number</th>
                        <th class="date-th">Invoice date</th>
                        <th>Company</th>
                        <th class="period">Invoice period</th>
                        <th>Amount</th>
                        <th>Due Date</th>
                        <th>Amount paid</th>
                        <th>Type</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class v-for="(invoice, k) in filteredInvoices" :key="k">
                        <th>{{ invoice.invoice_number }}</th>
                        <th class="date-th"></th>
                        <th class="created_by">{{ invoice.company_name }}</th>
                        <th class="period">
                            {{ invoice.period }}
                        </th>
                        <th class="Invoice_price">${{ invoice.amount }}</th>
                        <th></th>
                        <th>{{ invoice.paid }}</th>
                        <th>{{ invoice.type }}</th>
                        <th class="icon">
                            <div class="action-icon" title="Download" @click="downloadHendler(invoice.invoice_uuid)">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path
                                            fill="currentColor"
                                            d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                                    ></path>
                                </svg>
                            </div>
                            <div class="action-icon" title="Share" @click="sendHendler">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path
                                            fill="currentColor"
                                            d="M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
                                    ></path>
                                </svg>
                            </div>
                        </th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col col-md-4 col-sm-12 col-xs-12 per-page">
                <span class="filter_by">Show Per Page:</span>
                <div class="primary-input-container choose-type perPage">
                    <primary-select
                            type="text"
                            @input="changePerPage"
                            v-model="per_page" :is-cross="false"
                            class="choose-type perPage"
                            placeholder="Select"
                    >
                        <option :value="item" v-for="(item, key) in pages" :key="key">
                            {{ item }}
                        </option>
                    </primary-select>
                </div>
            </div>
            <div v-if="!isFound" class="buttons-wrapper pgn-box">
                <pagination-component
                        @change-page="changePage($event)"
                        :page="Page"
                        :total="TotalPages"
                        :perPage="per_page"
                        :qnt="filteredInvoices.length"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import {format} from "date-fns";

    export default {
        components: {
            DownloadAttachmentDropDown: () =>
                import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
            SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            PaginationComponent: () => import("@/components/Pagination.vue"),
            Loader: () => import("@/components/Loader.vue"),
            NotFound: () => import("@/components/NotFound.vue"),
            DateTimePicker: () => import("@/components/DateTime"),
        },
        data: () => ({
            showDropDown: false,
            company_uuid: null,
            companies: [],
            invoices: [],
            filteredInvoices: [],
            allInvoices: [],
            PerPage: null,
            TotalPages: null,
            Searched: "",
            Page: 0,
            total: 0,
            pages: [10, 50, 100],
            per_page: 10,
            loading: true,
            isFound: false,
        }),
        watch: {
            PerPage() {
                this.Page = 0;
            },
            company_uuid(id) {
                this.GetList();
            },
        },
        created() {
            this.GetCompanyList();
            this.GetList(this.Searched, this.Page);
        },
        methods: {
            getStartTime(t) {
                // const time = new Date(t).getTime();
                // this.start_time = time / 1000;
                console.log(t);
            },
            getEndTime(t) {
                // const time = new Date(t).getTime();
                // this.end_time = time / 1000;
                console.log(t);
            },
            searching(e) {
                this.Searched = e;
                if (!e) {
                    this.GetList();
                    return;
                }
                this.GetList(e, this.Page);
            },
            downloadHendler(id) {
                this.$store
                    .dispatch("DownloadInvoice", id)
                    .then((res) => {
                            const csvContent = 'data:text/csv;charset=utf-8,' +
                                Object.entries(res).map(e => {
                                    return e
                                }).join('\n')

                            var link = document.createElement('a')
                            link.href = csvContent
                            link.download = 'invoice.csv'
                            link.click()
                        }
                    )
            },
            sendHendler() {
                console.log("Send");
            },
            changePage(page) {
                this.Page = page;
                const url = `/invoice/list?company_name=${this.Searched}`;
                this.GetList(this.Searched, this.Page, url);
            },
            changePerPage() {
                const url = `/invoice/list?company_name=${this.Searched}`;
                this.GetList(undefined, null, url);
            },
            GetCompanyList() {
                this.$store.dispatch("GetCompanyList", {}).then((res) => {
                    const {total} = res;

                    this.$store
                        .dispatch("GetCompanyList", {per_page: total})
                        .then((res) => {
                            console.log(res);
                            this.companies = [
                                {name: "Select company", value: null},
                                ...res.items.map(this.tansformCompany),
                            ];
                        });
                });
            },
            GetList(search, page, url = null) {
                this.loading = true;
                this.isFound = false;
                this.$store
                    .dispatch("GetInvoiceList", {
                        url: url,
                        search: search,
                        page: page,
                        perPage: this.per_page ? this.per_page : 10,
                        company_uuid: this.company_uuid || null,
                    })
                    .then((res) => {
                        console.log(res);
                        this.loading = false;
                        if (!res.items.length) {
                            this.isFound = true;
                            return;
                        }
                        this.invoices = this.filteredInvoices = res.items.map(
                            this.transformInvoices
                        );
                        this.PerPage = res.per_page;
                        this.TotalPages = res.total / res.per_page;
                    });
            },
            tansformCompany(item) {
                return {
                    name: item.company_name,
                    value: item.company_uuid,
                };
            },
            transformInvoices(i, k) {
                this.total += i.amount;
                return {
                    ...i,
                    invoice_start_date: format(i.invoice_start_date, "YYYY:MM:DD HH:mm:ss"),
                    invoice_end_date: format(i.invoice_end_date, "YYYY:MM:DD HH:mm:ss"),
                    amount_paid: i.amount_paid,
                    invoiceId: i.invoice_uuid,
                    date: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
                    period: `${format(i.invoice_start_date, "YYYY:MM:DD")} - ${format(
                        i.invoice_end_date,
                        "YYYY:MM:DD"
                    )}`,
                    amount: i.amount,
                    type: i.type,
                    paid: i.paid,
                };
            },
            outside() {
                this.showDropDown = false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .invoice-container {
        .spinner-contaner {
            width: 100%;
        }

        .per-page {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 20px;
            padding: 0;
        }

        .perPage {
            width: 120px;
            display: inline-block;
        }

        .clr-padding {
            padding-left: 0;
            padding-right: 0;
        }

        .filter_by {
            margin-right: 15px;
        }

        .buttons-wrapper {
            justify-content: flex-end !important;
            width: 100%;
        }

        .pgn-box {
            width: 100%;
        }

        .add-navigation {
            .date-inputs {
                display: flex;
                margin-left: 20px;
                margin-top: -5px;
            }

            .date-picker:first-child {
                margin-right: 15px;
            }
        }

        @media (max-width: 1400px) {
            .custom-row {
                width: 100%;
            }
        }
        @media (max-width: 767px) {
            .add-navigation {
                display: block !important;
                height: auto !important;
            }
            .buttons-wrapper {
                justify-content: flex-start !important;
                margin-top: 15px;
            }
            .add-navigation .primary-button {
                width: 180px !important;
                margin-top: 10px !important;
            }
            .perPage {
                margin-top: 5px;
            }
        }
        @media (max-width: 600px) {
            .col.row.col-xs-12 > div {
                display: contents !important;
            }
            .buttons-wrapper {
                width: 100% !important;
            }
            .col-lg-6.col-md-7.col-xs-12 {
                margin-top: 15px;
            }
        }

        .add-navigation .search-input {
            display: inline-block !important;
        }

        .primary-button {
            width: 190px;
            margin-left: 20px;
        }

        .search-input {
            margin-bottom: 15px;
        }

        .add-navigation {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: auto;
            width: fit-content;
            float: left;
            margin-top: 20px;
            margin-bottom: 20px;

            .search-input {
                height: 40px;
                width: 100%;
                background-color: #ffffff;
            }

            .primary-button {
                height: 40px;
                width: 190px;
            }
        }

        .buttons-wrapper {
            display: flex;
            align-items: center;

            .secondary-button {
                height: 40px;
                width: 90px;
                margin-right: 15px;
            }
        }

        .total {
            width: 100%;
            height: 60px;
            margin-top: 20px;
            box-shadow: inset 0 -1px 0 0 #f0f1fa;
            -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
            -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
            background-color: #ffffff;
            text-align: right;
            font-size: 25px;
            font-family: "Helvetica Neue";
            padding: 13px 0 12px 40px;
            color: #000000;
            font-weight: bold;
            line-height: 30px;
        }
    }

    .Invoice_table {
        tr {
            width: 100%;
            height: 44px;
            box-shadow: inset 0 -1px 0 0 #f0f1fa;
            -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
            -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
            background-color: #ffffff;

            .date-th {
                width: 180px;
                padding-left: 0;
                padding-right: 0;
            }
        }

        .icon {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 44px;
            padding: 0;

            .action-icon:last-child {
                margin-right: 0;
            }

            .action-icon {
                width: 24px;
                height: 24px;
                margin-right: 10px;
                padding: 5px;
                border-radius: 50%;
                background: #c6c6c6;
                cursor: pointer;

                svg {
                    width: 100%;
                    height: 100%;
                    margin-top: -10px;
                    transform: rotateY(180deg);

                    path {
                        fill: #fff;
                    }
                }
            }
        }
    }

    .Invoice_table_popup {
        text-align: right;
        position: relative;
        float: right;

        .popup_cta {
            cursor: pointer;
            color: #55616e;
        }
    }

    .popup_content {
        display: none;
    }

    .popup_cta {
        cursor: pointer;
    }

    table.Invoice_table {
        width: 100%;
        margin-top: 21px;

        tbody {
            .period {
                padding-left: 0;
                padding-right: 0;
            }
        }

        .period {
            width: 200px;
        }
    }

    table thead tr {
        background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
    }

    .Invoice_table thead th:first-child {
        padding-left: 20px;
        padding-right: 30px;
        width: 14%;
    }

    .Invoice_table tbody tr th {
        color: #212b36;
        font-weight: normal;
        font-family: "Helvetica Neue";
        // height: 20px;
        font-size: 14px;
        font-weight: normal;
        // line-height: 20px;
        padding: 7px 10px 7px 20px;
        text-align: center;
    }

    table tr th {
        padding: 7px 10px 7px 0;
    }

    table {
        border-collapse: collapse;
    }

    .Invoice_table_header th {
        color: white;
        padding-left: 10px;
        border-bottom-width: 2px;
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        text-align: center;
    }

    .Invoice_table table thead th:first-child {
        padding-left: 35px;
    }

    .Invoice_table tbody th:first-child {
        padding-left: 20px;
    }

    .Invoice_table tbody th.company_inc {
        width: 110px;
        color: #55616e;
        font-weight: normal;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        padding: 13px 0 12px 0;
    }

    .Invoice_price {
        font-family: "Helvetica Neue";
        /*padding: 13px 0 12px 40px;*/
        color: #000000;
        font-weight: bold;
        line-height: 25px;
    }

    .Invoice_table_header th.Invoice_header_total {
        padding-left: 40px;
    }

    .Invoice_table_popup.active .popup_content {
        display: block;
        position: absolute;
        right: 0;
        width: 240px;
        border-radius: 4px;
        background-color: #ffffff;
        box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
        padding-left: 0;
        list-style-type: none;
        text-align: left;
    }

    .Invoice_table_popup.active .popup_content a {
        color: #55616e;
        font-size: 16px;
        line-height: 20px;
        text-decoration: none;
        font-family: "Helvetica Neue";
        padding: 10px 15px;
        display: inline-block;
    }

    .popup_image {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 8px;
    }

    th.status:after {
        content: "";
        height: 10px;
        width: 10px;
        background-color: #24e2b8;
        position: absolute;
        border-radius: 50%;
        left: 12px;
        top: 20px;
    }

    th.user_active {
        text-align: left;
        position: relative;
        padding: 0 0 0 12px;
    }

    @media (max-width: 1600px) {
        table.Invoice_table {
            width: 1500px;
        }
    }

    .table_div::-webkit-scrollbar {
        // width: 5px;
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table_div::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.44, #51a3f3),
                        color-stop(0.72, #51a3f3),
                        color-stop(0.86, #51a3f3)
        );
    }
    .date-time{
      margin-top: -5px;
    }

</style>

